import React from 'react';

import { Button } from '@capintel/component-lib/button';
import { SearchInput } from '@/views/components/inputs';

import { FormattedMessage, formatMessage } from '@/utils/i18n';
import { PERMISSIONS, userHasPermissionEnabled } from '@/utils/permissions';

import User from '@/types/user';
import Nullable from '@/types/nullable';

interface ContactDetailsComparisonsHeaderProps {
  comparisons?: any[];
  comparisonSearchQuery: string;
  isComparisonsLoading: boolean;
  debouncingSearch: boolean;
  user?: Nullable<User>;
  onSearchComparison: (query: string) => void;
  clearSearchComparison: () => void;
  onCreateComparison: () => void;
}

export const ContactDetailsComparisonsHeader: React.FC<ContactDetailsComparisonsHeaderProps> = ({
  comparisons,
  comparisonSearchQuery,
  isComparisonsLoading,
  debouncingSearch,
  user,
  onSearchComparison,
  clearSearchComparison,
  onCreateComparison,
}) => {
  const i18nBasePath = 'ContactDetails.Content.Comparisons';
  const hasComparisons = comparisons?.length || comparisonSearchQuery;

  return (
    <div className="contact-details-comparisons-header">
      <h3 className="contact-details-comparisons-header-title">
        <FormattedMessage id={`${i18nBasePath}.Header.Title`} />
      </h3>

      {hasComparisons && (
        <div className="contact-details-comparisons-header-actions">
          <SearchInput
            className="search-input-v2"
            onChange={onSearchComparison}
            placeholder={formatMessage(`${i18nBasePath}.Header.Actions.SearchComparison`)}
            rightSection={comparisonSearchQuery ? <i className="icon-cross-thin clear-term" onClick={clearSearchComparison} /> : undefined}
            value={comparisonSearchQuery}
            loading={!!isComparisonsLoading || debouncingSearch}
          />
          {userHasPermissionEnabled(user, PERMISSIONS.COMPARISONS_CREATE) && (
            <Button variant="primary" icon="add" onClick={onCreateComparison} data-testid="contact-details-create-comparisons">
              <FormattedMessage id={`${i18nBasePath}.Header.Actions.CreateComparison`} />
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
